import { render, staticRenderFns } from "./EditDueDate.vue?vue&type=template&id=0748e471&scoped=true&"
import script from "./EditDueDate.vue?vue&type=script&lang=js&"
export * from "./EditDueDate.vue?vue&type=script&lang=js&"
import style0 from "./EditDueDate.vue?vue&type=style&index=0&id=0748e471&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0748e471",
  null
  
)

export default component.exports